import { Phone } from "lucide-react";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const CallButton = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a href="tel:+919959271353" 
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black hover:bg-green-600 text-yellow-300 p-4 rounded-full shadow-lg flex items-center justify-center">
        <Phone size={24}  />
      </a>
    </div>
  );
};

export default CallButton;
